<template>
    <div class="flex-grow-1 file-control-container" :class="bgClass">
        <div class="file-control d-flex align-items-center justify-content-center">
            <span class="file-control__text" :class="textClass">{{text}}</span>
            <font-awesome-icon class="file-control__icon" :icon="icon" :class="iconClass"></font-awesome-icon>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        icon: Array,
        text: String,
        bgClass: String,
        textClass: String,
        iconClass: String
    }
}
</script>
<style scoped>
.file-control-container {
    flex-basis: 0;
}
.file-control {
    padding: 0.25em 0.5em;
    border-left: 1px solid #dee2e6;
    border-right: 1px solid #dee2e6;
    cursor: pointer;
}
.file-control__text {
    text-transform: uppercase;
    font-size: 0.9em;
}
.file-control__icon {
    margin-left: 0.5em;
}
.file-control:hover {
    background: rgba(0,0,0,0.1);
}
</style>


// WEBPACK FOOTER //
// src/components/file-elements/file-control.vue